'use client'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import AppLink from '@/components/elementary/AppLink'
import { ArrowLeft } from '@/components/icons/ArrowLeft'
import { usePathname } from '@/i18n/navigation'
import { cn } from '@/lib/styles'

export function BackButton({ className }: { className?: string }) {
	const pathname = usePathname()

	const t = useTranslations('general')

	const parentPath = useMemo(() => {
		const currentPath = String(pathname ?? '/')

		if (currentPath === '/') return '/'

		const cleanPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath
		const segments = cleanPath.split('/')

		const parentSegments = segments.slice(0, -1)
		const parent = parentSegments.join('/')

		return parent || '/'
	}, [pathname])

	return (
		<div className={cn(className)}>
			<AppLink
				href={parentPath}
				iconLeft={<ArrowLeft className="size-5" />}
				className="lok-text-body-regular-medium"
			>
				{t('back')}
			</AppLink>
		</div>
	)
}

export default BackButton
